import React from 'react';
import { observer } from 'mobx-react-lite';

import { SpaceMenu } from '../space-menu';
import { SpaceSelector } from '../space-selector';
import { ProducerLogo } from '../../../components/logo/producer-logo';
import { ProjectMenu } from '../../../routes/project/components/project-menu';
import { uiStore } from '../../../core/stores/ui-store';

import type { DrawerComponentProps } from './drawer';

import styles from './project-drawer.module.scss';
export const ProjectDrawer: React.FC<DrawerComponentProps> = observer(({ isOpen, space }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['left-container']} data-icon="true">
        <ProducerLogo />

        <SpaceSelector
          space={space}
          isOpen={isOpen}
          onClose={() => (uiStore.isDrawerOpen = false)}
        />

        <SpaceMenu space={space} onClose={() => (uiStore.isDrawerOpen = false)} />
      </div>

      <ProjectMenu onSelect={() => (uiStore.isDrawerOpen = false)} isOpen />
    </div>
  );
});
